// extracted by mini-css-extract-plugin
export var bold = "_rn-0";